module.exports = __webpack_public_path__ + "static/MT-bf27a5ace813cca37a24071c5aa536cd.svg";